import { useEffect, useMemo, useState, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { SVGPureIcon } from '@/ui';
import ChatInput from './components/input';
import MessageList from '@/components/chat-history/MessageList';
import BackBottomButton from '@/components/chat-history/BackBottomButton';
import { observer } from 'mobx-react-lite';
import chatStoreManager from '@/store/chat/manager';
import navbarStore from '@/store/navbar';
import globalStore from '@/store/global';
import agentStore from '@/store/agentStorage';
import { HelperCore } from '@/common/helper';
import HeaderMenu from './components/header-menu';
import Prompts from './components/prompts';
import Watermark from '@/components/watermark';
import tti_icon from '@/assets/img/tti_icon.png';
import inputTypeStore from '@/components/input-file/input-type';
import { RobotsMap } from '@/common/localRobot.js';
import Loader from '@/common/helper/loader';
import { AssistantType } from '@shared/constants/chat';
import { ConversationContext } from '@/components/chat-history/context';
// 文件上传
import { usePageDropzone } from '@/components/page-dropzone';
import knowledgeModelSelectStore from '../chat-knowledge/components/knowledege-model-select/store';
import McpPanel from '@/components/chat-history/mcpItem/panel';
import CheckAction from './components/checkAction';
import checkStore from '@/store/checkStore';
import HtmlViewer from '@/components/html-viewer';
import { useMeasure } from 'react-use';
import KnowledgeWelcome from '@/components/knowledge-welcome';
import "./index.scss";
import urlStore from '@/store/chat/urlStore';
import serverChoiceStore from '@/components/server-choice/store';
import Conf from '@/common/conf';
import mutilKnowledgeStore from '@/components/chat/MultiKnowledge/store';
import SimpleInput from './components/input/simple';
import { Tooltip } from 'antd';
import useIsAiso, { useIsAgentChat, useIsModelChat } from '@/hooks/useIsAiso';
import agentInstallStore from '@/pages/chat/components/agent-install/store'
import userStore from '@/store/user';

if (import.meta.env.MODE === 'dev') {
  window.navbarStore = navbarStore
}
function Chat(props) {
  const {
    scene = "", // knowledge: 知识库
    knowledgeId,
    knowledgeksId,
    chatKnowledgeStore,
  } = props;
  const { id } = useParams();
  const { isOwnShare, kn_continue_chat, entrance, ks_id, fold_id, file_id } = useMemo(() => {
    const { isOwnShare, ks_id, fold_id, file_id, entrance } = HelperCore.getParams();
    return {
      isOwnShare,
      entrance: Number(entrance || 0),
      ks_id,
      fold_id,
      file_id,
      kn_continue_chat: { cid: id, ks_id, fold_id, file_id },
    };
  }, [id]);
  const [showBackBottomButton, setShowBackBottomButton] = useState(false)
  const containerRef = useRef(null);
  const isKnowledgeChat = scene == "knowledge";
  const chatInputRef = useRef(null)
  const currentLocation = useLocation();
  const [$refContainer, { width: widthContainer }] = useMeasure();
  const [$refChatContainer, { width: widthChatContainer }] = useMeasure();
  const isAiso = useIsAiso();

  const chatStore = useMemo(() => {
    if(isKnowledgeChat){
      return chatStoreManager.current;
    }
    if(id && chatStoreManager.has(id)){
      const needLog = chatStoreManager.currentId != id;
      chatStoreManager.setCurrentId(id);
      const store = chatStoreManager.get(id);
      if(needLog){
        store.log({
          key: "aibot_chat",
          action: "show",
          ext: "history",
        });
      }
      return store;
    }
    if(!id && chatStoreManager.current && !chatStoreManager.current.chatId){
      return chatStoreManager.current;
    }

    const store = chatStoreManager.newChatStore({ id, kn_continue_chat, entrance, ks_id, fold_id, file_id });
    return store;
  }, [id, chatStoreManager.current]);

  const {
    canAborting,
    currAsstId,
    isAITyping,
    historyData,
    messageList,
    chatHeaderInfo,
    isLoadingHeaderInfo,
    isAgent,
    agentInfo,
    chatId,
    lastKnowledge,
    mcpStore,
    modelInfo,
  } = chatStore;

  const asstInfo = useMemo(() => {
    const asstId = chatHeaderInfo?.id || currAsstId;
    return navbarStore.chatModels[asstId] || RobotsMap[asstId] || {};
  }, [chatHeaderInfo, navbarStore.chatModels, chatStore.currAsstId]);

  useEffect(() => {
    if(lastKnowledge){
      const ids = Object.keys(lastKnowledge);
      if(ids.length){
        mutilKnowledgeStore.setListSelected(ids);
      }
    }
    else {
      mutilKnowledgeStore.clear();
    }

    // 开启新会话
    if(location.pathname == "/chat"){
      mutilKnowledgeStore.init("pc_model_kn_mode", true);
    }
  }, [lastKnowledge, checkStore.data.isShowCheck]);

  const asstCount = useMemo(() => {
    if (!messageList?.length || !chatHeaderInfo || mcpStore.agentId) return '';
    let count = HelperCore.removeRepeatArray(
      messageList.map(item => item.role_id)
    ).length;
    count = chatHeaderInfo?.count > count ? chatHeaderInfo?.count : count;
    if (count > 1) {
      return ` 和 ${count - 1}个其他助手`;
    }
    return '';
  }, [messageList?.length, chatHeaderInfo, mcpStore.agentId]);

  // TODO prompts 表单 ---start---
  // TODO 是否展示 prompts 表单列表
  const promptRef = useRef(null)
  const [isPromptTyping, setPromptTyping] = useState(false)
  const [promptsList, setPromptsList] = useState(null)
  const promptStrRef = useRef('') // 缓存prompts表单内容
  /** 将 prompts 同步到输入框 */
  const insertPrompts = data => {
    promptStrRef.current = data
  }
  const openPrompts = () => {
    setPromptTyping(true)
  }
  const closePrompts = () => {
    setPromptTyping(false)
  }
  useEffect(() => {
    // mcp对话
    if (chatStore?.mcpStore?.isAgent) {
      setPromptsList(chatStore.mcpStore.agentInfo?.prompt_form || [])
    } else {
      // 普通对话
      setPromptsList(agentInfo?.basic_info?.prompt_form)
    }
    return () => {
      promptRef.current?.close()
      setPromptsList(null)
    }
  }, [agentInfo, chatStore.mcpStore.agentInfo])
  // prompts 表单 ---end---
  useEffect(() => {
    chatStore.fetchChatHeaderInfo(id, asstInfo?.icon);
  }, [id]);

  // 拼接数字助手 icon 等信息
  useEffect(() => {
    if (messageList.length) {
      navbarStore.getSpecifyList(messageList.map(item => item.role_id));
    }
  }, [messageList?.length]);

  const disabledLocalChat = useMemo(() => {
    const asstId = chatHeaderInfo?.id || currAsstId;
    const isLocal = RobotsMap[asstId] ? true : false;
    const model = navbarStore.chatModels[asstId];
    const chatType = chatStoreManager.current?.historyData?.chat_type
    return (chatType === AssistantType.LocalModel
    || chatType === AssistantType.APIModel
    || chatType === AssistantType.PrivateModel
    || isLocal) && !model ? true : false;
  }, [chatHeaderInfo, navbarStore.chatModels, chatStoreManager.current?.historyData?.chat_type]);

  const disableAICreator = useMemo(() => {
    const asstId = chatHeaderInfo?.id || currAsstId;
    const model = navbarStore.chatModels[asstId];
    return model?.id === 'f6744f7b3ed4b9335629ea81c624402b' || model?.id === 'b0ea319e26ea848cd9685d264d8c6f51';
  }, [chatHeaderInfo?.id, chatStore.currAsstId]);

  const backBottomButtonChange = (val) => {
    setShowBackBottomButton(val)
  }

  useEffect(() => {
    if(!/^\/(chat|agentchat|aichat)/.test(currentLocation.pathname) || !historyData.title){
      globalStore.setDocumentInfo({
        title : Conf.appName,
      })
    }
    else {
      // 新建会话、切换会话中，显示 appName
      if(historyData.title == Loader.defaultChatTilte){
        globalStore.setDocumentInfo({
          title : Conf.appName,
        });
      }
      else {
        globalStore.setDocumentInfo({
          title : historyData.summary_title || historyData.title, // 先title, 会话完成变成AI总结的title
        })
      }
    }
  }, [historyData.title, currentLocation, historyData.summary_title]);

  useEffect(() => {
    return () => {
      // 清空智能体 id  防止从别的地方进入时携带上次的智能体id
      agentStore.setAgentId(null);
    }
  }, []);

  useEffect(() => {
    if(containerRef?.current) {
      const canScroll = containerRef.current.scrollHeight > containerRef.current.clientHeight
      const showBack = canScroll ? containerRef.current.scrollHeight - containerRef.current.scrollTop - containerRef.current.clientHeight > Loader.autoScrollToBottomGap : false
      backBottomButtonChange(showBack)
    }
  }, [containerRef?.current,messageList]);

  // 通过判断是否存在 <UploadButton id=Tag_UploadButton /> 组件来决定是否激活拖放上传
  const [activeDropzone, setActiveDropzone] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      const isUploadBtn = document.getElementById('Tag_UploadButton')
      if (isUploadBtn) {
        return setActiveDropzone(true)
      }
      setActiveDropzone(false)
    }, 500)
    // 切换页面时关闭安装流程
    agentInstallStore.setInstallerEnd()
    agentInstallStore.hideInstaller()
  }, [currentLocation])
  const {getRootProps, HideInput, isDragActive, DragArea, } = usePageDropzone({
    currAsstId,
  })

  useEffect(() => {
    checkStore.reset()
  }, [chatStore])

  // 显示标题，优先取总结的
  const conversationTitle = useMemo(() => {
    // conversation/info 接口返回 summary_title 后，可以去掉从 navbarStore 取的逻辑
    const historyConversation = navbarStore.historyList.find(item => item.conversation_id == id);
    if(historyConversation){
      return historyConversation.title;
    }
    return historyData.summary_title || historyData.title;
  }, [id, historyData]);

  const handleSend = ({ value, fileType, generate_type, html_message_id, ctx_extra_id = [], kwargs }) => {
    // mcp工具是否重新选择
    const isMcpServerChange = serverChoiceStore.checkServerChange();

    let newValue = value
    if (isPromptTyping) {
      promptRef.current.getPrompt()
      promptRef.current?.close()
      newValue = promptStrRef.current + '\n' + newValue
    }
    if(isKnowledgeChat){
      if(knowledgeModelSelectStore.curId){
        if(!knowledgeModelSelectStore.curId.includes("_")){
          if(knowledgeModelSelectStore.curId != chatKnowledgeStore.chatStore?.currAsstId){
            chatKnowledgeStore.createNewChatStore(knowledgeId, knowledgeksId, true);
          }
        }
        else {
          const [roleId, knModelId] = knowledgeModelSelectStore.curId.split("_");
          if(roleId != chatKnowledgeStore.chatStore?.currAsstId || knModelId != chatKnowledgeStore.chatStore?.lastMessage?.kn_custom_model?.id){
            chatKnowledgeStore.createNewChatStore(knowledgeId, knowledgeksId, true);
          }
        }
      }

      chatKnowledgeStore.chatStore.sendMessage({
        input: newValue,
        fileType,
        ...inputTypeStore.getSendParams(fileType),
        ...(
          knowledgeId
            ? {
              ks_id: knowledgeksId,
              dataset: {
                [knowledgeId]: [],
              },
            }
            : {}
        ),
        ...{ dataset_src: 1 },
      });
      chatKnowledgeStore.setEmptyKnowledges({
        [knowledgeId] : false,
      });
    }
    // 如果智能体类型已变化，开启新会话
    else if(chatStore.mcpStore.isAgent && chatStore.mcpStore.agentTypeNotMatch){
      urlStore.newAiAgentChat(chatStore.aiAgentId, newValue, {
        fileType,
        ...inputTypeStore.getSendParams(fileType),
        ...(id && isOwnShare == 0 ? {kn_continue_chat}:{})
      })
    }
    // mcp工具有变化时，开启新会话
    else if (isMcpServerChange) {
      const _chatStore = chatStoreManager.newChatStore({
        type: 10,
        asstId : chatStore.currAsstId,
        input: newValue,
      });

      globalStore.navigate(`/chat`);

      _chatStore.sendMessage({
        input: newValue,
        fileType,
        ...inputTypeStore.getSendParams(fileType),
        ...(id && isOwnShare == 0 ? {kn_continue_chat}:{}),
        entrance // //0.默认,1.知识库
      });
    } else {
      chatStore.sendMessage({
        input: newValue,
        fileType,
        ...inputTypeStore.getSendParams(fileType),
        ...(id && isOwnShare == 0 ? {kn_continue_chat}:{}),
        entrance, // //0.默认,1.知识库
        generate_type,
        kwargs,
        html_message_id,
        ...(ctx_extra_id.length > 0 ? { ctx_extra_id } : {}),
      });
    }
  }

  useEffect(() => {
    mcpStore.setHtmlPreview(false);
    mcpStore.setCurrentFileNode(null);
    mcpStore.setShowRightPanel(false);
  }, [currentLocation]);

  const rightPanel = useMemo(() => {
    if(!mcpStore.isAgent && mcpStore.currentFileIsHtmlNode){
      return (
        <div
          className={'size-full'}
          >
          <HtmlViewer
            conversation_id={id}
            msg_id={mcpStore.currentFileNode.messageId}
            title={mcpStore.currentFileNode.title}
            url={mcpStore.currentFileNode.url}
            shareUrl={mcpStore.currentFileNode.share_url}
            content={
              // 会统一为 content，临时先兼容老数据，确认模型更新后去掉
              mcpStore.currentFileNode.content
              || mcpStore.currentFileNode.result
            }
            type={mcpStore.isAgent || mcpStore.isMcpServer ? "agent" : mcpStore.currentFileNode.type}
            fileName={mcpStore.currentFileNode.title}
            mcpStore={mcpStore}
            onClose={
              () => {
                mcpStore.setCurrentFileNode(null)
              }
            }
            />
        </div>
      )
    }

    return mcpStore.showRightPanel ? <McpPanel mcpStore={mcpStore} /> : null
  }, [
    mcpStore.showRightPanel,
    mcpStore.currentFileNode,
    mcpStore.currentFileIsHtmlNode,
    mcpStore.isAgent,
    mcpStore.fixedFileNode,
    widthContainer,
    id,
  ])

  const renderHeader = () => {
    return (
      <header
        id="chat-header"
        className={[
          'h-72px pl-24px pr-20px pt-16px pb-12px',
          'flex justify-between items-center',
          'flex-shrink-0 border-bottom-1px border-black border-opacity-10 bg-white',
        ]}
        ref={$refChatContainer}
        style={Loader.getChatContainerStyle({ showRightPanel : chatStore.mcpStore.isRightOpen })}
      >
        <section
          className={`flex items-center h-40px gap-12px flex-1 ${!id || historyData.title != Loader.defaultChatTilte ? '' : 'invisible'}`}
        >
          <>
            <Tooltip title="返回">
              <div
                className={`size-32px bg-light-50 flex items-center justify-center rounded-8px hover:bg-black hover:bg-opacity-3 cursor-pointer ${navbarStore.isCollapse ? 'ml-40px' : ''}`}
                onClick={() => {
                  chatStore.log({
                    action : "click",
                    set : "back",
                  });
                  if(userStore.isBrand){
                    globalStore.navigate(-1);
                    return;
                  }
                  globalStore.gotoHome();
                }}
                >
                <SVGPureIcon name="header_back_arrow" className={`size-24px text-black hover:text-[#333]`} />
              </div>
            </Tooltip>
            {(asstInfo.icon && !isLoadingHeaderInfo) || isAgent ? (
              <>
                <div className={`relative size-40px rounded-full overflow-hidden border-1px border-[rgba(0,0,0,0.06)]`}>
                  <img
                    className="size-40px rounded-12px object-cover flex-shrink-0"
                    src={Loader.getModelIcon(modelInfo)}
                  />
                  {asstInfo.conversation_type == 1 ? (
                    <img
                      className="size-17px object-cover absolute left-0 bottom-0"
                      src={tti_icon}
                    />
                  ) : null}
                </div>
                <span className="flex flex-col gap-2px w-0 flex-grow mr-12px">
                  <strong className="text-16px font-smibold leading-snug truncate">
                    {conversationTitle}
                  </strong>
                  <span className="text-12px text-primary-opacity text-opacity-50 leading-16px truncate">
                    {modelInfo?.title}
                    {asstCount}
                  </span>
                </span>
              </>
            ) : chatStore.mcpStore.agentInfo ? (
              <>
                <div className={`relative size-40px rounded-full overflow-hidden border-1px border-[rgba(0,0,0,0.06)]`}>
                  <img
                    className="size-40px rounded-12px object-cover flex-shrink-0"
                    src={chatStore.mcpStore.agentInfo.icon || chatStore.mcpStore.agentInfo.images}
                  />
                </div>
                <span className="flex flex-col gap-2px w-0 flex-grow mr-12px">
                  <strong className="text-16px font-smibold leading-snug truncate">
                    {conversationTitle}
                  </strong>
                  <span className="text-12px text-primary-opacity text-opacity-50 leading-16px truncate">
                    {chatStore.mcpStore.agentInfo.title}
                  </span>
                </span>
              </>
            ) : null }
          </>
        </section>
        <HeaderMenu messageList={messageList} conversation_id={id} isAITyping={isAITyping} widthChat={widthChatContainer} showRightPanel={mcpStore.showRightPanel } />
      </header>
    )
  }

  return (
    <ConversationContext.Provider
      value={{
        conversationId : chatId,
        modelInfo,
      }}>
      <Watermark className="!w-0 !flex-grow">
        <div
          className="size-full flex flex-col"
          style={{
            background: 'linear-gradient(rgba(255, 255, 255, 0) 0px, rgb(255, 255, 255) 100%), url(https://p2.ssl.qhimg.com/t110b9a93013be09a129a3803c2.png) repeat center center / 20px 20px',
          }}
        >
          {
            // isKnowledgeChat || isAiso
            isKnowledgeChat
            ? null
            : renderHeader()
          }
          <div className="flex w-full h-0 flex-grow" ref={$refContainer}>
            <div
              className="w-1/2 relative h-full flex-grow overflow-hidden flex flex-col"
              {...getRootProps(activeDropzone)}
            >
              { isDragActive ? <DragArea active={activeDropzone} /> : null }
              <HideInput active={activeDropzone} />


              {
                messageList?.length
                  ? <MessageList ref={containerRef} items={messageList} isAgent={isAgent} isKnowledgeChat={isKnowledgeChat} knowledgeId={knowledgeId} kn_continue_chat={id && isOwnShare == 0 ? kn_continue_chat: {}} entrance={entrance} backBottomButtonChange={backBottomButtonChange} handleSend={handleSend}/>
                  : null
              }
              {
                !messageList?.length && isKnowledgeChat && chatKnowledgeStore.emptyKnowledges[knowledgeId]
                ? (
                  <KnowledgeWelcome onSend={handleSend} knowledgeId={knowledgeId} knowledgeksId={knowledgeksId} />
                )
                : null
              }
              {
                checkStore.data.isShowCheck
                ? (
                  <CheckAction />
                )
                : (
                <>
                  <div
                    className={[
                      'absolute right-0px bottom-0 left-0 z-1',
                      'flex flex-col items-center',
                    ]}
                  >
                    {showBackBottomButton ? (
                      <BackBottomButton
                        className='absolute -top-12px transform -translate-y-full'
                        onClick={() => {
                          if (containerRef?.current) {
                            containerRef.current.scrollTop = containerRef.current.scrollHeight;
                          }
                        }}
                      />
                    ) : null}
                    {(promptsList && promptsList.length > 0)
                      && <Prompts
                          ref={promptRef}
                          items={promptsList}
                          // items={[{name: '算命大师'}, {name: '发财运'}, {name: '恋爱分析师'}]}
                          submit={data => insertPrompts(data)}
                          open={() => {
                            chatStore.log({
                              action : "click",
                              set : "template_button",
                            })
                            openPrompts();
                          }}
                          close={() => closePrompts()}
                          classnames={['min-w-366px']}
                          overrideFormClassnames={{
                            maxwidth: 832, // 最大宽度
                            minwidth: 366, // 最小宽度
                          }}
                        />
                    }
                    <section
                      id="NM-ASSISTANT_chat_input"/** 0227用于定位prompt表单 */
                      className={[
                        'z-9 relative w-full',
                        mcpStore.isRightOpen ? '' : 'max-w-872px',
                        'px-48px',
                      ]}
                      style={{
                        ...Loader.getChatContainerStyle({ isKnowledgeChat, showRightPanel : mcpStore.isRightOpen }),
                      }}
                    >
                      <div
                        className={[
                          'rounded-t-24px',
                          'w-full h-full pb-32px',
                          'flex flex-col items-center',
                          'bg-white',
                          // isAiso && mcpStore.isRightOpen ? 'pl-62px' : '',
                        ]}
                      >
                        {disabledLocalChat ? (
                          <div className="py-10px">
                            本地模型仅支持在客户端使用
                          </div>
                        ) : disableAICreator ? (
                          <div className="py-10px">
                            AI修图大师仅支持在移动端使用
                          </div>
                        ) : isAiso ? (
                          <SimpleInput
                            ref={chatInputRef}
                            agentInfo={agentInfo}
                            canAborting={canAborting}
                            isAITyping={chatStore.isAITyping}
                            isPromptTyping={isPromptTyping}
                            disabled={chatStore.isAITyping}
                            isKnowledgeChat={isKnowledgeChat}
                            onSend={handleSend}
                          />
                        ) : (
                          <ChatInput
                            ref={chatInputRef}
                            agentInfo={agentInfo}
                            canAborting={canAborting}
                            isAITyping={chatStore.isAITyping}
                            isPromptTyping={isPromptTyping}
                            disabled={chatStore.isAITyping}
                            isKnowledgeChat={isKnowledgeChat}
                            onSend={handleSend}
                          />
                        )}
                      </div>
                    </section>
                  </div>

                  {/* 底部小字协议 */}
                  <div
                    className="absolute left-0 right-0 bottom-0 flex w-full justify-center text-12px text-primary-opacity text-opacity-30 pt-8px pb-12px z-1"
                    style={{
                      background: '#fff',
                    }}
                  >
                    以上内容均由AI大模型生成，仅供参考
                    {isKnowledgeChat ? null : (
                      <div className="ml-16px">
                        请遵守
                        <a
                          className="!text-[#006BFF] hover:underline whitespace-nowrap cursor-pointer"
                          style={{ color: 'inherit' }}
                          target="_blank"
                          href={`/agreements/protocol`}
                          onClick={() => {}}
                        >
                          《用户协议》
                        </a>
                        和
                        <a
                          className="!text-[#006BFF] hover:underline whitespace-nowrap cursor-pointer"
                          style={{ color: 'inherit' }}
                          target="_blank"
                          href={`/agreements/privacy`}
                          onClick={() => {}}
                        >
                          《隐私协议》
                        </a>
                      </div>
                    )}
                  </div>
                </>
                )
              }
            </div>
            <div className={`${mcpStore.showRightPanel || (!mcpStore.isAgent && mcpStore.currentFileIsHtmlNode) ? 'w-1/2' : 'w-0'}`}>
              { rightPanel }
            </div>
          </div>
        </div>
      </Watermark>
    </ConversationContext.Provider>
  );
}

function StopButton({ className, onClick }) {
  return (
    <button
      className={[
        'group',
        'absolute',
        'transform',
        '-top-10px -translate-y-full',
        'left-1/2 -translate-x-1/2',
        'rounded-[8px] border-1px border-black-10',
        'pl-[10px] pr-[14px] py-6px',
        'flex gap-6px',
        'bg-button-bg-normal',
        className
      ]}
      onClick={event => onClick?.(event)}
    >
      <SVGPureIcon
        name="competitive-chat-stop"
        className="size-20px text-opacity-50 text-primary-opacity group-hover:text-opacity-80"
      />
      <div className="text-[14px] leading-[20px] text-primary-opacity text-opacity-50 group-hover:text-opacity-80">
        停止
      </div>
    </button>
  );
}

export default observer(Chat);
